import { render } from "./AsBannersTop.vue?vue&type=template&id=fb69c738&ts=true"
import script from "./AsBannersTop.vue?vue&type=script&lang=ts"
export * from "./AsBannersTop.vue?vue&type=script&lang=ts"

import "./AsBannersTop.vue?vue&type=style&index=0&id=fb69c738&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__